import * as imagesLoaded from 'imagesloaded'
import common from './common'
import index from './index'
import canvas from './canvas'

document.addEventListener('DOMContentLoaded', function() {
  imagesLoaded(document.getElementById('offset'), ()=>{
    const load = document.getElementById('load')
    if(load){
      load.remove()
    }
    canvas()
    setTimeout(()=>{
      common()
      index()
    },100)
  })

});